import type { AnyAction } from '@reduxjs/toolkit';
import { actions as tabCoordinationActions } from '@restore/readerViewerSession/tabCoordination/tabCoordination.slice';
import { formManagementSlice } from '@restore/readerViewerSession/formManagement/formManagement.slice';
import { runToast } from '@restore/tools';
import { DetachRpc } from '@dynamika/rpc-core/contracts';
import { detachRpcScheme } from './scheme';

/** Main receives state changes from the detached host. */
export const registerMainDetachListeners = (
  dispatch: (action: AnyAction) => unknown
): (() => void) => {
  const unsubscribers = [
    // Real orchestration (dirty reset, cache flush, navigation), so it goes to
    // the saga under its own wire name — as viewer notifications do.
    detachRpcScheme.listeners.onContextChanged(payload => {
      dispatch({ type: DetachRpc.Events.CONTEXT_CHANGED, payload });
    }),
    detachRpcScheme.listeners.onFormChanged(payload => {
      dispatch(formManagementSlice.actions.changeScoringFormData(payload));
    }),
  ];

  return () => unsubscribers.forEach(unsubscribe => unsubscribe());
};

/** Detached receives local UI commands from the main host. */
export const registerDetachedListeners = (
  dispatch: (action: AnyAction) => unknown
): (() => void) => {
  const unsubscribers = [
    detachRpcScheme.listeners.onDeactivate(() => {
      dispatch(tabCoordinationActions.setIsDeactivated(true));
    }),
    detachRpcScheme.listeners.onNotice(({ message }) => {
      if (message) runToast('info', message);
    }),
    detachRpcScheme.listeners.onOperationFailed(({ name, message }) => {
      runToast('error', message ?? `${name === 'complete' ? 'Sign' : 'Save'} failed`);
    }),
  ];

  return () => unsubscribers.forEach(unsubscribe => unsubscribe());
};
